import {transformSelectOptions} from "@/util/ComponentUtils";
import {YesNoEnum, SyggenikiSxesiEnum} from "@/util/EnumUtil";


const getDefaultState = () => {
    return {
        parametric: {
            aitiaKthshs: null,
            staticList: {...(YesNoEnum), ...(SyggenikiSxesiEnum)}
        }
    }
}

export const namespaced = true
export const state = getDefaultState()

export const mutations = {
    SET_AITIA_KTHSHS(state, data) {
        state.parametric.aitiaKthshs = data
        state.parametric.staticList = {...(YesNoEnum), ...(SyggenikiSxesiEnum)}
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    }
}

export const actions = {
    setAitiaKthshs({commit}, data) {
        commit('SET_AITIA_KTHSHS', data)
    },
    resetState({commit}) {
        commit('RESET_STATE')
    },
}

export const getters = {
    getAitiaKthshs: (state) => {
        try {
            return transformSelectOptions(state.parametric.aitiaKthshs, 'eidos', 'Επιλέξτε Αιτία Κτήσης')
        } catch (e) {
            return []
        }
    },
    getYesNo: (state) => state.parametric.staticList.yesNo,
    getSyggenikiSxesi: (state) => state.parametric.staticList.syggenikiSxesi,
    isTaxisData: (state) => state.parametric.staticList.isTaxisData,
}
